// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".choose-order-list{height:100%}.choose-order-list .table-list{height:calc(100% - 64px)}.choose-order-list .table-list .el-table{color:#282729}", ""]);
// Exports
module.exports = exports;
